export class InverterSetupBase {
    panelCount: number;
    invID: string;
    invName: string;

    constructor(panelCount: number, invID: string, invName: string) {
        this.panelCount = panelCount;
        this.invID = invID;
        this.invName = invName;
    }
}
